var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSafeFormData, } from '../types/index';
import { useCalendarIntegrationsContext } from '../context/CalendarIntegrationContext';
import { useHandleEventUpdate } from '../hooks/useHandleEventUpdate';
import { useEventComposerGlobalContext } from './EventComposerGlobalContext';
import { useEventApi } from '../hooks/useEvent/useEventApi';
import { useConfig } from '../context/ConfigContext';
import { useSpacePrivacySettings } from '../hooks/useSpacePrivacySettings';
var EditEventContext = createContext({
    initialEvent: undefined,
    eventPermissions: undefined,
    handleEventUpdate: function () { },
    recurringEventToUpdate: null,
    setRecurringEventToUpdate: function () { },
    editEventError: null,
    updatingEvent: false,
    setEditEventError: function () { },
    shouldShowPrivacyIndicator: false,
    spaceReservationVisibilityEnabled: false,
});
export var EditEventContextProvider = function (_a) {
    var _b;
    var children = _a.children, onClose = _a.onClose, onSubmit = _a.onSubmit, onEventChange = _a.onEventChange, initialEvent = _a.initialEvent, eventPermissions = _a.eventPermissions, fetchingEvent = _a.fetchingEvent;
    var _c = useConfig(), tenantId = _c.tenantId, environmentUrls = _c.environmentUrls, userContext = _c.userContext, accessToken = _c.accessToken;
    var _d = useEventComposerGlobalContext(), timezone = _d.timezone, onError = _d.onError;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var subscribe = useFormContext().subscribe;
    var formData = useSafeFormData();
    var _e = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }), updateEvent = _e.updateEvent, editEventError = _e.eventError, setEditEventError = _e.setEventError, updatingEvent = _e.composingEvent;
    var _f = useCalendarIntegrationsContext(), calendarType = _f.calendarType, calendarMailboxAddress = _f.calendarMailboxAddress;
    var _g = __read(useState(null), 2), recurringEventToUpdate = _g[0], setRecurringEventToUpdate = _g[1];
    var _h = useSpacePrivacySettings((_b = formData.spaces) !== null && _b !== void 0 ? _b : []), spaceReservationVisibilityEnabled = _h.spaceReservationVisibilityEnabled, shouldShowPrivacyIndicator = _h.shouldShowPrivacyIndicator;
    var handleEventUpdate = useHandleEventUpdate({
        formData: formData,
        timezone: timezone,
        initialEvent: initialEvent,
        calendarType: calendarType,
        calendarMailboxAddress: calendarMailboxAddress,
        updateEvent: updateEvent,
        setRecurringEventToUpdate: setRecurringEventToUpdate,
        onError: onError,
        onClose: onClose,
        onSubmit: onSubmit,
    }).handleEventUpdate;
    useEffect(function () {
        if (fetchingEvent)
            return;
        if (!onEventChange)
            return;
        var callback = subscribe({
            formState: {
                values: true,
            },
            callback: function (_a) {
                var values = _a.values;
                onEventChange(values);
            },
        });
        return function () { return callback(); };
    }, [subscribe, onEventChange, fetchingEvent]);
    return (_jsx(EditEventContext.Provider, { value: {
            initialEvent: initialEvent,
            eventPermissions: eventPermissions,
            handleEventUpdate: handleEventUpdate,
            recurringEventToUpdate: recurringEventToUpdate,
            setRecurringEventToUpdate: setRecurringEventToUpdate,
            editEventError: editEventError,
            updatingEvent: updatingEvent,
            setEditEventError: setEditEventError,
            shouldShowPrivacyIndicator: shouldShowPrivacyIndicator,
            spaceReservationVisibilityEnabled: spaceReservationVisibilityEnabled,
        }, children: children }));
};
export var useEditEventContext = function () {
    return useContext(EditEventContext);
};
